export default __webpack_public_path__ + "static/media/f_md-1.ec9f476a.svg";